<template>
  <div>
    <q-item
      clickable
      dense
      @click.stop="toggleAll"
    >
      <q-item-section side>
        <q-checkbox
          :model-value="determinate"
          :indeterminate-value="null"
          :toggle-indeterminate="false"
          dense
          @update:modelValue="toggleAll"
        />
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-weight-bold">All Post Statuses</q-item-label>
      </q-item-section>
    </q-item>
    <q-item
      v-for="option in options"
      :key="option.value"
      clickable
      dense
      @click.stop="toggle(option.value)"
    >
      <q-item-section side>
        <q-checkbox
          :model-value="isSelected(option.value)"
          dense
          @update:modelValue="toggle(option.value)"
        />
      </q-item-section>
      <q-item-section>
        <q-item-label class="row items-center no-wrap">
          {{ option.label }}
          <q-space />
          <q-icon
            v-if="option.tooltip"
            name="fas fa-info-circle"
            size="xs"
            color="grey-6"
            class="q-ml-xs"
          >
            <q-tooltip>{{ option.tooltip }}</q-tooltip>
          </q-icon>
        </q-item-label>
      </q-item-section>
    </q-item>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { LifecycleStatus } from '@/type';

interface Option {
  value: LifecycleStatus,
  label: string,
  tooltip?: string,
}

interface Data {
  options: Option[],
}

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Array as () => LifecycleStatus[] | null,
      default: null,
    },
  },
  data(): Data {
    return {
      options: [
        { label: 'Archived', value: LifecycleStatus.ARCHIVED },
        {
          label: 'Deleted',
          value: LifecycleStatus.TRASHED,
          tooltip: 'Posts that were deleted within 30 days of their initial import into Private Footprint',
        },
      ],
    };
  },
  computed: {
    allSelected(): boolean {
      return this.modelValue === null;
    },
    determinate(): boolean | null {
      if (this.allSelected) return true;
      const hasPartialSelection = this.modelValue
        && this.modelValue.length > 0
        && this.modelValue.length < this.options.length;
      return false;
    },
  },
  methods: {
    isSelected(val: LifecycleStatus): boolean {
      return this.allSelected
        || (this.modelValue !== null && this.modelValue.includes(val));
    },
    toggleAll() {
      if (!this.allSelected) {
        this.$emit('update:modelValue', null);
      }
    },
    toggle(val: LifecycleStatus) {
      if (this.allSelected) {
        // Switching from implicit all: select all except the toggled one
        const updated = this.options
          .map((o: Option) => o.value)
          .filter((v: LifecycleStatus) => v !== val);
        this.$emit('update:modelValue', updated);
      } else {
        const current = this.modelValue || [];
        const updated = current.includes(val)
          ? current.filter((s: LifecycleStatus) => s !== val)
          : [...current, val];
        this.$emit('update:modelValue', updated);
      }
    },
  },
});
</script>
